<template>
  <div>
    <table class="table table-striped" style="border-bottom: 1px solid #dee2e6">
      <thead>
        <tr>
          <th
            class="text-truncate"
            style="background-color: #334697; color: white"
            >Engine Name</th
          >
          <th
            class="text-truncate"
            style="background-color: #334697; color: white"
            >Last RH Date</th
          >
          <th
            class="text-truncate"
            style="background-color: #334697; color: white"
            >Last RH</th
          >
          <th
            class="text-truncate"
            style="background-color: #334697; color: white"
            >Total RH</th
          >
        </tr>
      </thead>
      <tbody>
        <tr v-for="(rh, engineIndex) in runningHours" :key="engineIndex">
          <td class="text-truncate">{{ rh?.power_type?.name }}</td>
          <td class="text-truncate">{{ '-' }}</td>
          <td class="text-truncate">{{ rh?.this_month }} Hours</td>
          <td class="text-truncate">{{ rh?.total_running_hour }} Hours</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { pmsActions } from '@/src/Utils/helper'
import moment from 'moment'

export default {
  name: 'MaintenanceRhList',
  props: {
    maintenanceDetailData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      runningHours: [],
    }
  },
  methods: {
    ...pmsActions,
    async fetchData() {
      const params = {
        vehicle_id: this.maintenanceDetailData?.vehicle?.id,
      }
      const res = await this.getPmsRunningHours(params)

      if (res?.status === 'success') {
        this.runningHours = res.data.data
        console.log(this.runningHours)
      } else {
        console.log(res)
      }
      this.loading = false
    },
    formatDate(date) {
      return date ? moment(date, 'DD-MM-YYYY').format('DD/MM/YYYY') : '-'
    },
  },
  mounted() {
    this.fetchData()
  },
}
</script>

<style scoped>
.font-medium {
  font-weight: 500;
}
</style>
